import React, { useEffect, useState } from "react";

// components
import { Button, Card, CardBody, CardHeader, Form, Row, Col, Spinner } from "reactstrap";
import MaterialTable from 'material-table';

// style
import { table_translate, table_style } from "constants/MaterialTable.js";

// views
import UsuarioFicha from "./UsuarioFicha";

// helpers
import { showMessage } from "helpers/message.js";

// api
import usuario_api from "api/usuario_api.js";

export default function UsuarioLista() {

  const [showLoading, setshowLoading] = React.useState(false);

  const [list_table, set_list_table] = React.useState([]);
  const [rowEdit, set_rowEdit] = React.useState(null);
  const [showDetail, set_showDetail] = React.useState(false);
  
  const handleAdd = () => {
    set_rowEdit(null);
    set_showDetail(true);
  }

  const handleEdit = (rowData) => {
    setshowLoading(true);
    usuario_api.getItem(rowData.usuario_Id).then(result => {
      setshowLoading(false);
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else {
        set_rowEdit(result.data);
        set_showDetail(true); 
      }
    }); 
  }

  const handleReturn = () => {
    set_rowEdit(null);
    set_showDetail(false);
    loadList();
  }

  const loadList = () => {
    setshowLoading(true);
    usuario_api.getAll().then(result => {
      setshowLoading(false);      
      if (result.status !== 200) {
        showMessage("Aviso", result.message, 'error', null);
      }
      else {
        set_list_table(result.data);
      }
    });
  }

  useEffect(() => {
    loadList();
  }, []);

  return (
    <>
      {showLoading &&
        <div className="carregandoCmp">
          <div className="box">
            <Spinner></Spinner>
          </div>
        </div>
      }
      <div className={showDetail ? "d-none" : "content"}>
        <Row>
          <Col md="12">
            <Button color="default" onClick={handleAdd}><i className="fa fa-plus"></i>  Novo Usuário</Button>
            <Card>
              <CardHeader>
                <h4 className="titleCard">Lista de Usuários</h4>
              </CardHeader>
              <CardBody>
                <Form>
                  <MaterialTable style={{ minHeight: "auto" }}
                    title=""
                    columns={[
                      { title: 'E-mail', field: 'email' },
                      { title: 'Nome', field: 'nome' },
                      { title: 'Perfil', field: 'perfil' },
                      { title: 'Status', field: 'status' }
                    ]}
                    data={list_table}
                    isLoading={false}
                    options={{
                      filtering: false,
                      exportButton: true
                    }}
                    actions={[
                      {
                        icon: 'search',
                        tooltip: 'Visualizar Registro',
                        onClick: (event, rowData) => handleEdit(rowData)
                      }
                    ]}
                    localization={table_translate}
                    options={table_style}
                  />
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
      {showDetail &&
        <UsuarioFicha item={rowEdit} handleReturn={handleReturn}></UsuarioFicha>
      }

    </>

  );
}